import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { PRECIPITATION_LEGEND } from './precipitation.legend';
import { PRECIPITATION_PRODUCT_DATA } from './precipitation.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class PrecipitationPluginService {
  private readonly _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(PRECIPITATION_PRODUCT_DATA, {
    legend: PRECIPITATION_LEGEND,
    twcLayerTypes: ['web-tile']
  });
}
